import axios from "axios";
import { API_BASE_URI, getApiBaseUri } from "library/constants/api";

function getBrochureApiBaseUrl(): string {
  if (process.env.REACT_APP_BROCHURE_API_URL) {
    return process.env.REACT_APP_BROCHURE_API_URL.replace(/\/$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:4001";
  }
  return "/bys/brochure-api";
}

function getAuthHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  } as const;
}

function handleAuthError(error: any) {
  if (error?.response?.status === 403) {
    localStorage.clear();
    sessionStorage.clear();
    window.open("/sign-in", "_self");
  }
  throw error;
}


export async function apiPost<T = any>(url: string, payload?: any): Promise<T> {
  try {
    const response = await axios
      .post(`${API_BASE_URI}${url}`, payload, { headers: getAuthHeaders() })
      .catch(handleAuthError);

    return response?.data;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
}

export async function apiPatch<T = any>(url: string, payload?: any): Promise<T> {
  try {
    const response = await axios
      .patch(`${API_BASE_URI}${url}`, payload, { headers: getAuthHeaders() })
      .catch(handleAuthError);

    return response?.data;
  } catch (error) {
    console.error("API PATCH request failed:", error);
    throw error;
  }
}

export async function apiDelete<T = any>(url: string): Promise<T> {
  try {
    const response = await axios
      .delete(`${API_BASE_URI}${url}`, { headers: getAuthHeaders() })
      .catch(handleAuthError);

    return response?.data;
  } catch (error) {
    console.error("API DELETE request failed:", error);
    throw error;
  }
}

export async function apiGet<T = any>(url: string): Promise<T> {
  try {
    const response = await axios
      .get(`${API_BASE_URI}${url}`, { headers: getAuthHeaders() })
      .catch(handleAuthError);

    return response?.data;
  } catch (error) {
    console.error("API GET request failed:", error);
    throw error;
  }
}

export async function brochureApiPost<T = any>(
  url: string,
  payload?: any,
): Promise<T> {
  try {
    const response = await axios
      .post(`${getBrochureApiBaseUrl()}${url}`, payload, {
        headers: getAuthHeaders(),
        timeout: 180000,
      })
      .catch(handleAuthError);

    return response?.data;
  } catch (error) {
    console.error("Brochure API request failed:", error);
    throw error;
  }
}

export { getApiBaseUri };
